import { useEffect } from 'preact/hooks'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { SearchPageLink } from 'libs/searchspring/components/quick-search/SearchPageLink'

/**
 *
 * @typedef defaultSuggestions
 * @type {suggestion[]}
 *
 * @typedef suggestion
 * @property {string} title
 * @property {string} url
 */

export function QuickSearchSuggestions({ query, defaultSuggestions }) {
  const { results, refine } = useSearchspringContext()

  useEffect(() => {
    if (query) {
      refine('query', query)
    }
  }, [query])

  if (results?.items?.length === 0 && !defaultSuggestions?.length > 0) return null

  // Create a combined array of suggestions to display
  const displaySuggestions = [...(results?.items || [])]

  // If we have default suggestions and fewer than 4 results, append default suggestions
  if (defaultSuggestions && displaySuggestions.length < 4) {
    // Only add enough default suggestions to reach a total of 4
    const suggestionsToAdd = defaultSuggestions.slice(0, 4 - displaySuggestions.length)

    // Add default suggestions to the display suggestions array
    displaySuggestions.push(...suggestionsToAdd)
  }

  return (
    <div className="flex flex-col flex-grow w-full">
      {displaySuggestions.map((suggestion, index) => {
        // Check if this is a search result or a default suggestion
        if (suggestion.query !== undefined) {
          // This is a search result item
          return (
            <SearchPageLink
              key={`result-${index}`}
              query={suggestion.query}
              className="paragraph-base group"
            >
              <span className={'inline-block group-hover:show-wavy-underline wavy-underline py-2 whitespace-nowrap first-letter:capitalize'}>{suggestion.label}</span>
            </SearchPageLink>
          )
        } else {
          // This is a default suggestion
          return (
            <SearchPageLink
              key={`default-${index}`}
              url={suggestion.url}
              className="paragraph-base group"
            >
              <span className={'inline-block group-hover:show-wavy-underline wavy-underline py-2 whitespace-nowrap first-letter:capitalize'}>{suggestion.title}</span>
            </SearchPageLink>
          )
        }
      })}
    </div>
  )
}
